import React from "react"
import Head from "next/head"
import { queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import MoodboardSearch from "@components/moodboard/MoodboardSearch/MoodboardSearch"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"
import emptySearchDesktop from "@images/pages/banners/emptySearchDesktop.jpg"
import emptySearchMobile from "@images/pages/banners/emptySearchMobile.jpg"

const MoodboardPage = ({ options, searchParams, seo }) => {
  const empty = {
    search: true,
    backgroundImage: {
      mobile: emptySearchMobile,
      desktop: emptySearchDesktop,
    },
    title: "",
    text: "Sorry, no images match. Try reducing the number of filters.",
    btnLabel: "CLEAR FILTERS",
    extra: {
      text: "Need a helping hand? Get in touch for free advice.",
      link: "mailto:hello@houseofpartyplanning.com",
    },
  }

  return (
    <Layout options={options}>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <Seo
        global={seo}
        title="Moodboard Search"
        description="Search through our moodboard images to find the suppliers for your next party"
      />
      <MoodboardSearch empty={empty} searchParams={searchParams} />
    </Layout>
  )
}

export default MoodboardPage

export async function getServerSideProps({ query }) {
  const { seo } = await request({ query: `{ ${queries.seo} }` })
  const options = await loadOptionsData()
  return {
    props: { options, searchParams: query, seo },
  }
}
